import React, { useEffect, useRef, useState } from "react";
import { useInViewport } from "react-in-viewport";

// Hooks
import useDevice from "../../hooks/useDevice";

// Components
import {
  Fade,
  Grid,
  AvatarGroup,
  Avatar,
  Divider,
  Typography,
} from "@mui/material";

const Attire = (props) => {
  const contentRef = useRef();
  const [startTransition, setStartTransition] = useState(false);
  const { inViewport } = useInViewport(contentRef);
  const { device } = useDevice();

  useEffect(() => {
    if (inViewport) setStartTransition(true);
  }, [inViewport]);

  return (
    <div {...props} className={`vjc_main-attire ${device}`}>
      <Divider>
        <Typography variant="h1" sx={{ fontSize: "26px" }}>
          Dress Code
        </Typography>
      </Divider>
      <Fade in={startTransition} timeout={2500}>
        <Grid container spacing={3} ref={contentRef}>
          <Grid item xs>
            <Typography
              variant="body2"
              color="text.secondary"
              style={{
                fontSize: "14px",
                fontWeight: "700",
                marginBottom: "10px",
              }}
            >
              Principal sponsor
            </Typography>
            <AvatarGroup max={5}>
              {["#000000", "#272829", "#545454", '#363636'].map(
                (color, index) => (
                  <Avatar key={index}>
                    <div style={{ backgroundColor: color }}></div>
                  </Avatar>
                )
              )}
            </AvatarGroup>
          </Grid>
          <Grid item xs>
            <Typography
              variant="body2"
              color="text.secondary"
              style={{
                fontSize: "14px",
                fontWeight: "700",
                marginBottom: "10px",
              }}
            >
              Guest
            </Typography>
            <AvatarGroup max={5}>
              {["#272829", "#545454", '#363636'].map(
                (color, index) => (
                  <Avatar key={index}>
                    <div style={{ backgroundColor: color }}></div>
                  </Avatar>
                )
              )}
            </AvatarGroup>
          </Grid>
        </Grid>
      </Fade>
      <Fade in={startTransition} timeout={3500}>
        <Typography variant="body2" color="text.secondary">
          WE'D LOVE TO SEE OUR FRIENDS AND FAMILY GET DRESSED UP FOR OUR BIG DAY.<br /><br />

          FOR NINONG, WE RECOMMEND <span style={{ fontWeight: "700" }}>BLACK SUIT AND PANTS, WHITE INNER AND BLACK NECK TIE.</span> <br /><br />
          FOR NINANG, <span style={{ fontWeight: "700" }}>DARK GRAY / ACID GRAY / CHARCOAL GRAY</span> COLOR LONG DRESS IN ANY STYLE OF YOUR
          PREFERENCE.<br /><br />

          FOR GUESTS, WE RECOMMEND A SEMI-FORMAL ATTIRE USING THE SUGGESTED COLOR PALETTE <span style={{ fontWeight: "700" }}>(DARK GRAY,
            ACID GRAY, CHARCOAL GRAY).</span>
        </Typography>
      </Fade>

      <Fade in={startTransition} timeout={3500}>
        <Typography
          variant="body2"
          color="text.secondary"
          style={{ fontWeight: 700, marginBottom: 0 }}
        >
          Strictly no t-shirts, shorts, and slippers.
        </Typography>
      </Fade>
    </div>
  );
};

export default Attire;
